<template>
<div v-if="can.view">

    <styles></styles>
    <div class="w-full xxl:w-5/6 mx-auto">

        <div id="eb-wrapper">
            <main class="bg-white rounded-6 mx-auto shadow-md text-body leading-normal site__color--text site__font--text" :class="previewWidth">
                <div v-html="customCss"></div>

                <site-component :data="{ type: 'site-menu' }"></site-component>

                <site-component :data="{ type: 'site-header' }" :can-create="canCreate" :can-edit="canEdit" />

                <div v-for="(component, index) in components" :key="index">
                    <site-component :data="component" :can-create="canCreate" :can-edit="canEdit" />
                </div>

                <site-component :data="{ type: 'site-footer' }"></site-component>
            </main>
        </div>

    </div>

    <add-component v-if="can.manage && addingComponent !== false" @close="cancelAddingComponent" />

    <component-configurator v-if="configuringComponent && can.manage" :component="configuringComponent" @close="cancelConfiguringComponent" />

    <header-configurator v-if="can.manage && configuringHeader" @close="cancelConfiguringHeader"/>
</div>
<error-403 v-else></error-403>
</template>


<script>
import {mapState, mapActions} from 'pinia';
import {useMainStore} from '../state/store';
import {useBrandingStore} from '../../shared/state/branding';

import Styles from '../../shared/components/jobsite/Styles.vue';
import SiteComponent from './SiteComponent.vue';
import AddComponent from './ui/AddComponent.vue';
import ComponentConfigurator from './ui/ComponentConfigurator.vue';
import HeaderConfigurator from './ui/HeaderConfigurator.vue';
import Error403 from './ui/Error403.vue';


export default {
    components: {
        'styles': Styles,
        'site-component': SiteComponent,
        'add-component': AddComponent,
        'component-configurator': ComponentConfigurator,
        'header-configurator': HeaderConfigurator,
        'error-403': Error403,
    },
    props: {
        canCreate: {type: Boolean, default: true},
        canEdit: {type: Boolean, default: true},
    },
    data: function () {
        return {};
    },
    computed: {
        ...mapState(useBrandingStore, ['components', 'preview', 'addingComponent', 'configuringComponent', 'configuringHeader']),
        ...mapState(useMainStore, ['currentCompany']),
        previewWidth () {
            return {
                phone: 'w-360',
                tablet: 'w-768',
                desktop: 'w-full min-w-1024'
            }[this.preview.type];
        },
        can () {
            return {
                view: this.$can(['jobsites.view', 'jobsites.manage']),
                manage: this.$can('jobsites.manage')
            };
        },
        customCss(){
            //Parse custom css with eb-wrapper to use custom css in the app eb
            if (this.currentCompany.jobsite.custom_css) {
                return '<style>' + this.scopeCustomCSS() + '</style>';
            }

            return '';
        },
    },
    methods: {
        ...mapActions(useBrandingStore, ['cancelAddingComponent', 'cancelConfiguringComponent', 'cancelConfiguringHeader',
            'fetchComponents', 'fetchFilterGroups']),
        scopeCustomCSS() {
            // This is needed to make sure the company's custom css doesn't affect the rest of the app, and only affects the #eb-wrapper container, which is the container for the jobsite in-app

            // Example of what this will do:
            // .my-class, .my-other-class { color: red; } => #eb-wrapper .my-class, #eb-wrapper .my-other-class { color: red; }

            // Regular expression to match CSS selectors and rules
            const cssRuleRegex = /([^{]+)\s*{([^}]*)}/g;

            // Modify each rule by prepending the wrapper ID
            return this.currentCompany.jobsite.custom_css.replace(cssRuleRegex, (match, selectors, rules) => {
                // Add the wrapper ID to each individual selector
                const scopedSelectors = selectors
                    .split(',')
                    .map(selector => `#eb-wrapper ${selector.trim()}`)
                    .join(', ');

                return `${scopedSelectors} { ${rules} }`;
            });
        }
    },
    mounted () {
        this.fetchComponents();
        this.fetchFilterGroups();
    },
}
</script>
